import { render, staticRenderFns } from "./ModalDetalleEnvio.vue?vue&type=template&id=5b6c3920"
import script from "./ModalDetalleEnvio.vue?vue&type=script&lang=js"
export * from "./ModalDetalleEnvio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports